import React, { FC } from "react";
import withContentWrap, { PropsType as WithContentWrapProps } from "../../hoc/withContentWrap";
import withVerticalSpacing, { PropsType as WithVerticalSpacingProps } from "../../hoc/withVerticalSpacing";
import withTheme, { PropsType as WithThemeProps } from "../../hoc/withTheme";
import Button from "../Button";
import "./style.scss";

type ButtonType = {
    id: string;
    url: string;
    target: string;
    label: string;
};

type PropsType = WithContentWrapProps &
    WithVerticalSpacingProps &
    WithThemeProps & {
        buttons: Array<ButtonType>;
        alignment: "left" | "center" | "right";
    };

const Buttons: FC<PropsType> = props => (
    <div className={`Buttons Buttons--${props.alignment}`}>
        {props.buttons.map(button => (
            <div key={button.id} className="Buttons__button">
                <Button url={button.url} target={button.target} title={button.label} theme={props.theme}>
                    {button.label}
                </Button>
            </div>
        ))}
    </div>
);

export default withVerticalSpacing(withContentWrap(withTheme(Buttons)));
